import React from 'react'

import { StyledScrollbars } from './styles'

interface IProps {
    height?: number | string
    className?: string
}

export const Scrollbars: React.FC<IProps> = ({ height, children, className }) => {
    return (
        <StyledScrollbars className={className} style={{ height: height ?? '100%' }}>
            {children}
        </StyledScrollbars>
    )
}
